import React from 'react';
import { Route } from 'react-router-dom';
import CampaignRoutes from './Campaign/routes';
const routes = () => [<CampaignRoutes key="CampaignRoutes" />];

const CampaignRoute = () => <Route component={routes} />;

export default CampaignRoute;



// WEBPACK FOOTER //
// src/modules/screens/campaign/routes.js